$(document).ready(function(){
          console.log('new');
          $.ajax({
            type: "GET",
            dataType:'json',
            crossDomain:true,
            url: 'https://ifeedapp.herokuapp.com/api/?type=get_media&user_id=17841401603838910',
            success: function(response){
              console.log(response);
              var html = "";
              $(response.data).each(function(k,v){
                
                var mediaHTML = "";
                
                if(v.media_type == "VIDEO"){
                  mediaHTML = '<img src="'+v.thumbnail_url+'" />';
                }
                
                if(v.media_type == "IMAGE" || v.media_type == "CAROUSEL_ALBUM"){
                  mediaHTML = '<img src="'+v.media_url+'" />';
                }
                
                if(k < 12){
                  k = k+1;
				  if(k == 1 || k == 4 || k == 7 || k == 10){
					  html += "<div class='col'>";
				  }
					  html += '<a target="_blank" href="'+v.permalink+'" title="'+v.username+'">'+mediaHTML+'</a>';					
				  
				  if(k == 3 || k == 6 || k == 9 || k == 12){
					
					html += '</div>';
				  }
                }
              });
              $('.instapost').append(html);
            }
          });
        });